import { createFileRoute } from '@tanstack/react-router';
import DocsGroupSectionLanding from '@/components/Docs/DocsGroupSectionLanding';

export const Route = createFileRoute('/developers/$section/')({
  component: DevelopersSectionLandingPage,
});

function DevelopersSectionLandingPage() {
  const { section } = Route.useParams();
  return <DocsGroupSectionLanding group="developers" sectionSlug={section} />;
}
